class categoriesIndexPage {

    constructor() {

        // theme.js auto-initializes every ".swiper" element (including these
        // two) before this module runs. Destroy that instance first, same
        // fix as the product gallery's Swiper double-init, or the new
        // Swiper() calls below stack a second instance on top of it.
        // cleanStyles must stay false: these containers carry their own
        // server-rendered inline "flex: 8"/"flex: 2" sizing (not added by
        // Swiper), and cleanStyles=true strips the *entire* style attribute,
        // not just the properties Swiper itself set - collapsing the slider
        // to 0 height.
        const thumbEl = document.querySelector('#index-page-thumbnail-swiper');
        const mainEl = document.querySelector('#index-page-swiper');
        if (thumbEl && thumbEl.swiper) {
            thumbEl.swiper.destroy(true, false);
        }
        if (mainEl && mainEl.swiper) {
            mainEl.swiper.destroy(true, false);
        }

        const swiper = new Swiper("#index-page-thumbnail-swiper", {
            slidesPerView: 2,
            spaceBetween: 16,
            freeMode: true,
            watchSlidesProgress: true,
            breakpoints: {
                768: {
                    slidesPerView: 4
                }
            }
        });
        const swiper2 = new Swiper("#index-page-swiper", {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 16,
            autoplay: {
                delay: 4000
            },
            navigation: {
                "prevEl": "#prev",
                "nextEl": "#next"
            },
            thumbs: {
                swiper: swiper,
            },
        });
    }
}

export let CategoriesIndexPage = new categoriesIndexPage();
